var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBill13({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_8939",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 48,
    height: 48
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H48V48H0V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_8939)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 35C4 36.5913 4.63214 38.1174 5.75736 39.2426C6.88258 40.3679 8.4087 41 10 41C11.5913 41 13.1174 40.3679 14.2426 39.2426C15.3679 38.1174 16 36.5913 16 35C16 33.4087 15.3679 31.8826 14.2426 30.7574C13.1174 29.6321 11.5913 29 10 29C8.4087 29 6.88258 29.6321 5.75736 30.7574C4.63214 31.8826 4 33.4087 4 35Z",
    stroke: "#7B51F1",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32 35C32 36.5913 32.6321 38.1174 33.7574 39.2426C34.8826 40.3679 36.4087 41 38 41C39.5913 41 41.1174 40.3679 42.2426 39.2426C43.3679 38.1174 44 36.5913 44 35C44 33.4087 43.3679 31.8826 42.2426 30.7574C41.1174 29.6321 39.5913 29 38 29C36.4087 29 34.8826 29.6321 33.7574 30.7574C32.6321 31.8826 32 33.4087 32 35Z",
    stroke: "#7B51F1",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 37V29L18 23L28 15L32 21H38",
    stroke: "#7B51F1",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32 9C32 9.53043 32.2107 10.0391 32.5858 10.4142C32.9609 10.7893 33.4696 11 34 11C34.5304 11 35.0391 10.7893 35.4142 10.4142C35.7893 10.0391 36 9.53043 36 9C36 8.46957 35.7893 7.96086 35.4142 7.58579C35.0391 7.21071 34.5304 7 34 7C33.4696 7 32.9609 7.21071 32.5858 7.58579C32.2107 7.96086 32 8.46957 32 9Z",
    stroke: "#7B51F1",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBill13);
export default __webpack_public_path__ + "static/media/bill-13.4739dcf332e85ed53a44a1a4f352af48.svg";
export { ForwardRef as ReactComponent };